import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { EBaseOrderDirection } from 'common/models/requestModels';
import { IRegionModel } from 'entities/Region/Region.models';
import { regionTransport } from 'entities/Region/Region.transport';

interface IComponentProps {
  value?: string;
  onChange?: (regionId?: string) => void;
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
}

// ponytail: plain antd Select over a one-shot fetch — simpler than AbstractSearchableSelector,
// which models a single object value; here we only need an id + dependent Group filtering.
export const RegionSelector: React.FC<IComponentProps> = ({ value, onChange, placeholder, disabled, allowClear = true }) => {
  const [regions, setRegions] = useState<IRegionModel[]>([]);

  useEffect(() => {
    let active = true;

    regionTransport
      // ponytail: limit 100 (BE max) so regions beyond the 10th aren't silently dropped.
      .getRegionCollection({ limit: 100, orderDirection: EBaseOrderDirection.ASC } as any)
      .then((collection) => {
        if (active) {
          setRegions(collection.data);
        }
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, []);

  return (
    <Select
      allowClear={allowClear}
      showSearch
      className="width-full"
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      optionFilterProp="children"
      filterOption={(input, option) => (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())}
      onChange={(val) => onChange?.(val)}
      getPopupContainer={(triggerNode) => triggerNode as HTMLElement}
    >
      {regions.map((region) => (
        <Select.Option key={region.id} value={region.id}>
          {region.name}
        </Select.Option>
      ))}
    </Select>
  );
};
